var _defs, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointIntersectionSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointIntersection_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.53 22.46 16.05 16 4.45 8.87 1.61 10.46 9.62 15.61 1.61 20.54 5.53 22.46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17 15.41 28.08 8.6 24.39 6.54 16.5 11.38 8.61 6.54 5.45 8.31 17 15.41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.39 10.46 29.07 9.16 17.95 16 28.02 22.19 31.39 20.54 23.38 15.61 31.39 10.46"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17 16.59 6.59 22.98 9.61 24.46 16.5 20.04 23.39 24.46 26.96 22.71 17 16.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointIntersectionSvg);
export default __webpack_public_path__ + "static/media/NovapointIntersection_svg.e7995afba96b2245b4af0a8b29b51bb3.svg";
export { ForwardRef as ReactComponent };